<mat-icon [matTooltip]="'article.bio' | trans" class="on-valid" [class.bio-small]="size() === 'small'">eco</mat-icon>
